module.exports = __webpack_public_path__ + "img/facebook-sm.a60163bb.svg";